import { useEffect, useRef, useState } from 'react';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SocialDeliveryError from './SocialDeliveryError';

export default function TelegramDiagnostics({ connectionId }) {
  const { t } = useTranslation();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(false);
  const request = useRef(null);
  useEffect(() => () => request.current?.abort(), [connectionId]);
  const check = async () => {
    request.current?.abort();
    const controller = new AbortController();
    request.current = controller;
    setLoading(true);
    setFailed(false);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}messaging_connections/${connectionId}/telegram_diagnostics`, { signal: controller.signal });
      if (!response.ok) throw new Error('Diagnostic unavailable');
      const data = await response.json();
      if (!controller.signal.aborted) setResult(data);
    } catch (error) {
      if (!controller.signal.aborted) { setFailed(true); setResult(null); }
    } finally {
      if (!controller.signal.aborted) setLoading(false);
    }
  };
  return <div style={{ marginTop: 12 }}>
    <Button variant="outlined" size="small" onClick={check} disabled={loading}>
      {t(loading ? 'telegram_checking' : 'telegram_check_connection')}
    </Button>
    {failed && <p role="alert">{t('telegram_check_unavailable')}</p>}
    {result && <div aria-live="polite">
      <ul style={{ paddingLeft: 20 }}>
        {Object.entries(result.checks || {}).map(([key, passed]) =>
          <li key={key}>{passed ? '✓' : '⚠'} {t(`telegram_check_${key}`)}</li>)}
      </ul>
      {Object.values(result.checks || {}).some(passed => !passed) && <p>{t('telegram_check_fix_hint')}</p>}
      {result.stored?.auto_response_mode === 'opt_in' && <p>{t('reply_mode_opt_in_help')}</p>}
      <p>{t('telegram_pending_updates', { count: Number(result.telegram?.pending_update_count || 0) })}</p>
      {result.processing?.failed > 0 && <p>{t('telegram_failed_updates', { count: result.processing.failed })}</p>}
      <SocialDeliveryError error={result.last_error} />
    </div>}
  </div>;
}
